import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LAUNCHPAD_MODULES } from './homeConfig';

/** Odoo-style app launchpad: a cardless grid of clickable module tiles. */
const Launchpad = () => {
  const navigate = useNavigate();

  return (
    <section className="mb-10" data-testid="launchpad">
      <p className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500 mb-4">Applications</p>
      <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 lg:grid-cols-12 gap-3">
        {LAUNCHPAD_MODULES.map((mod, i) => {
          const Icon = mod.icon;
          return (
            <button
              key={mod.id}
              onClick={() => navigate(mod.path)}
              data-testid={`launchpad-module-${mod.id}`}
              className="group flex flex-col items-center justify-center p-4 rounded-xl border border-transparent hover:border-orange-200 hover:bg-orange-50/60 transition-colors animate-in fade-in-0 slide-in-from-bottom-2"
              style={{ animationDelay: `${i * 35}ms`, animationFillMode: 'both' }}
            >
              <span className="w-12 h-12 rounded-xl bg-slate-100 group-hover:bg-white border border-slate-200 group-hover:border-orange-200 flex items-center justify-center transition-colors">
                <Icon className="w-6 h-6 text-slate-600 group-hover:text-orange-600 transition-colors" strokeWidth={1.5} />
              </span>
              <span className="text-xs font-semibold text-slate-700 mt-2 text-center leading-tight">{mod.label}</span>
            </button>
          );
        })}
      </div>
    </section>
  );
};

export default Launchpad;
